import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fb53574e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb53574e')) {
      api.createRecord('fb53574e', component.options)
    } else {
      api.reload('fb53574e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fb53574e&", function () {
      api.rerender('fb53574e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JYZa1XPWxKJL/JS/comp/ErrorMessage.vue"
export default component.exports